import { BrowserRouter } from 'react-router-dom'

import { QueryClientProvider } from '@tanstack/react-query'

import RouterApp from 'app/routes/router'

import ErrorHoc from 'widgets/error-hoc/error-hoc'

import queryClient from 'shared/lib/query-client'

declare global {
  interface Window {
    ym: (code: unknown, name: unknown, tag: unknown) => void

    gtag: (name: string, params: unknown, options?: unknown) => void
  }
}

window.ym = window.ym || {}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ErrorHoc path={location.pathname}>
          <RouterApp />
        </ErrorHoc>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
